import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from '../components/layout/AppLayout/AppLayout';
import { PageLoader } from '../components/ui';
import Login from '../modules/auth/pages/Login';
import NotFound from './pages/NotFound';
import { useAuth } from './providers/AuthProvider';
import { ItemsRedirect, PAGES, RequireAuth, RequireRole } from './router';

// The dashboard is loaded on its own so the chart library (recharts) stays out of the main bundle.
const Dashboard = lazy(() => import('../modules/dashboard/pages/Dashboard'));

export default function App() {
  const { user, booting } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={booting ? <PageLoader /> : user ? <Navigate to="/" replace /> : <Login />} />
      <Route
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route index element={<Suspense fallback={<PageLoader />}><Dashboard /></Suspense>} />
        {PAGES.map(({ path, page: Page, roles }) => (
          // key: /x/new and /x/:id/edit share a component; a new key gives each route fresh state.
          <Route key={path} path={path} element={<RequireRole key={path} roles={roles}><Page /></RequireRole>} />
        ))}
        <Route path="items" element={<ItemsRedirect />} />
        <Route path="items/:id" element={<ItemsRedirect />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
